const bbsRouter =
{
  path: '/bbsgroup',
  name: 'Bbs',
  redirect: '/bbsgroup/index',
  meta: {
    title: '社区论坛'
  },
  component: () => import('@/views/bbsHome/index.vue'),
  children:
    [
      {
        path: 'index',
        name: 'Indexpage',
        component: () => import('@/views/bbsThread/index.vue')
      },
      {
        path: 'classify',
        name: 'Classify',
        component: () => import('@/views/bbsThread/classify.vue')
      },
      {
        path: 'datalist',
        name: 'Datalist',
        component: () => import('@/views/bbsThread/datalist.vue'),
        meta: { title: '小组主页' }
      },
      {
        path: 'treemap',
        name: 'Treemap',
        component: () => import('@/views/bbsThread/treemap.vue'),
        meta: { title: '社区地图' }
      },
      {
        // path: '/postDetail/tid/:tid/f/:f?/page/:page?/floor/:floor?/width/:width?',
        path: 'd/:tid',
        name: 'D',
        component: () => import('@/views/bbsDetails/index'),
        content: {
          keywords: '',
          description: ''
        }
      },
      {
        path: 'updateReplay',
        name: 'updateReplay',
        component: () => import('@/views/bbsDetails/updateReplay'),
        meta: { title: '编辑回复' }
      },
      // 分享案例 之前 选小组
      {
        path: 'sendPosts',
        name: 'SendPosts',
        component: () => import('@/views/bbsThread/tsendPosts.vue')
      },
      // 发帖 之前 选小组
      {
        path: 'newlist',
        name: 'BbsNewList',
        component: () => import('@/views/bbsThread/tsendList.vue')
      },
      // 发帖
      {
        path: 'doc',
        name: 'DOC',
        component: () => import('@/views/bbsThread/threadPost.vue'),
        meta: { title: '发帖' }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: () => import('@/views/bbsThread/setupBBS.vue'),
        meta: { title: '小组设置' }
      },
      {
        path: 'prviegroup',
        name: 'PrvieGroup',
        component: () => import('@/views/bbsThread/privateGroup.vue'),
        meta: { title: '申请加入小组' }
      }
    ]
}
export default bbsRouter
